import axios from 'axios';
const userData =  JSON.parse(localStorage.getItem("persist:userData"));
let authToken = '';

if(userData && userData.authToken){
    authToken = userData.authToken.replace(/"/g,'');
}
let userProfile = ''
if (userData && userData.user) {
    userProfile = JSON.parse(userData.user)
}
// export default 
const instance = axios.create({
    baseURL:`${process.env.REACT_APP_API_URL}api/`,
    // headers:{
    //     "content-type": "application/json",
    //     "AccessToken": authToken ? authToken :'bdmBHjJbAH1lyG1mkQgjbouPXImaighEXd4qJD3p7iemnFbnH6lwifudqsAM',
    //     "UserId": userProfile && userProfile.userId ? userProfile.userId.toString():"2"
    // }
})

 // Set the AUTH token for any request
 instance.interceptors.request.use(function (config) {
     // const token = localStorage.getItem('token');
     const userData =  JSON.parse(localStorage.getItem("persist:userData"));
     let authToken = '';
     
     if(userData && userData.authToken){
         authToken = userData.authToken.replace(/"/g,'');
        }
        let userProfile = ''
        if (userData && userData.user) {
            userProfile = JSON.parse(userData.user)
        }
        config.headers.AccessToken =  authToken ? authToken :'bdmBHjJbAH1lyG1mkQgjbouPXImaighEXd4qJD3p7iemnFbnH6lwifudqsAM';
        config.headers.UserId =  userProfile && userProfile.userId ? userProfile.userId.toString():"2";
        //console.log('interceptors', config);
    return config;
  });

export default instance;
